// src/pages/Archive/ArchivePage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spin, Card, Typography, Space, Tag, Select } from "antd";
import { UserOutlined } from "@ant-design/icons";
import BlogLayout from "../../components/BlogLayout";
import { useAuth, useTags } from "../../hooks/useBlogAPI";
import api from "../../api/blogAPI";
import "./ArchivePage.css";

const { Title } = Typography;

const ArchivePage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState(undefined);
  const { user } = useAuth();
  const { data: tags, loading: tagsLoading } = useTags();
  const navigate = useNavigate();

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const result = await api.getPosts(1, 100);
      const sortedArticles = [...result.data].sort(
        (a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)
      );

      setArticles(sortedArticles);
    } catch (error) {
      console.error("??????:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePost = () => {
    navigate("/posts/create");
  };

  const filteredArticles = selectedTag
    ? articles.filter((article) => (article.tags || []).includes(selectedTag))
    : articles;

  return (
    <BlogLayout user={user} onCreatePost={handleCreatePost}>
      <div className="container archive-page">
        <Card title={<Title level={2}>归档</Title>} className="archive-card">
          <div className="archive-filter">
            <span className="archive-filter-label">按标签筛选</span>
            <Select
              allowClear
              placeholder="请选择标签"
              loading={tagsLoading}
              value={selectedTag}
              onChange={(value) => setSelectedTag(value)}
              options={tags.map((tag) => ({
                value: tag.name,
                label: `${tag.name} (${tag.count})`,
              }))}
              style={{ minWidth: 220 }}
            />
          </div>

          <Spin spinning={loading}>
            <div className="archive-timeline">
              {filteredArticles.map((article, index) => {
                const dateText = new Date(
                  article.publishedDate
                ).toLocaleDateString();
                const isLast = index === filteredArticles.length - 1;

                return (
                  <div
                    key={article.id}
                    className={`timeline-item${isLast ? " last-item" : ""}`}
                  >
                    <div className="timeline-date">{dateText}</div>
                    <div
                      className="timeline-card"
                      onClick={() => navigate(`/posts/${article.id}`)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          navigate(`/posts/${article.id}`);
                        }
                      }}
                    >
                      <div className="timeline-title">
                        <Typography.Link>{article.title}</Typography.Link>
                      </div>
                      <div className="timeline-meta">
                        <Space size="middle">
                          <span>
                            <UserOutlined /> {article.author}
                          </span>
                          {article.tags &&
                            article.tags.map((tag) => (
                              <Tag color="blue" key={tag}>
                                {tag}
                              </Tag>
                            ))}
                        </Space>
                      </div>
                      <div className="timeline-excerpt">
                        {article.content.length > 200
                          ? article.content.substring(0, 200) + "..."
                          : article.content}
                      </div>
                    </div>
                  </div>
                );
              })}
              {!loading && filteredArticles.length === 0 && (
                <div className="archive-empty">暂无该标签的文章</div>
              )}
            </div>
          </Spin>
        </Card>
      </div>
    </BlogLayout>
  );
};

export default ArchivePage;
